import { restApiCallback } from 'api/typed';
import { RestApiDefinition } from 'api/types';
import { TIMEOUT_CONFIG } from 'constants/checkout-api-timeout';

const postDefinition = {
  service: 'order-payment',
  endpoint: 'orders/${customerOrderId}/payments/gifting/access-token',
  verbs: ['post'],
  defaultVersion: 3,
  timeout: TIMEOUT_CONFIG,
} as const satisfies RestApiDefinition;

export interface OrderGiftCardsToken {
  token: string;
  publicKey: string;
  algorithm: string;
  keyVersion: string;
  salt: string;
}

export default {
  post: restApiCallback(postDefinition, 'post')<OrderGiftCardsToken>,
};
